import { Snackbar, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

interface UpdateBannerProps {
  /** Called when the user confirms the update (posts SKIP_WAITING to the waiting SW). */
  onReload: () => void;
  /** Called when the user dismisses the banner without updating. */
  onDismiss: () => void;
}

/**
 * Banner shown when a new service worker version is installed and waiting.
 * Rendered from src/index.tsx via an independent createRoot (NOT inside App) —
 * see the registration flow there for the mount/unmount lifecycle.
 */
export const UpdateBanner = ({ onReload, onDismiss }: UpdateBannerProps) => {
  const { t } = useTranslation();

  return (
    <Snackbar
      open
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      message={t('update.message')}
      action={
        <>
          <Button color="primary" size="small" onClick={onReload}>
            {t('update.reload')}
          </Button>
          <IconButton
            size="small"
            aria-label={t('update.dismiss')}
            color="inherit"
            onClick={onDismiss}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </>
      }
    />
  );
};
